import { Flex } from "styled-system/jsx";
import { Icon, Heading, Text, Button, ButtonProps } from "@ttc3k/trekker";
import { ReactNode } from "react";

export interface AppHeaderProps {
  Icon: React.ForwardRefExoticComponent<
    Omit<React.SVGProps<SVGSVGElement>, "ref"> &
      React.RefAttributes<SVGSVGElement>
  >;
  title: string;
  description: string;
  primaryButtonCopy?: string;
  primaryButtonProps?: ButtonProps;
  primaryButtonReplacement?: ReactNode;
  secondaryButtonCopy?: string;
  secondaryButtonProps?: ButtonProps;
}

export const AppHeader = ({
  Icon: IconElement,
  title,
  description,
  primaryButtonCopy,
  primaryButtonProps,
  primaryButtonReplacement,
  secondaryButtonCopy,
  secondaryButtonProps,
}: AppHeaderProps) => {
  const showPrimaryButton =
    primaryButtonCopy && primaryButtonProps && !primaryButtonReplacement;
  const showSecondaryButton = secondaryButtonCopy && secondaryButtonProps;

  return (
    <Flex direction={"column"} gap={"400"} maxW={"260px"}>
      <Flex direction={"column"} gap={"150"}>
        <Icon size={"xl"} Element={IconElement} />
        <Heading>{title}</Heading>
        <Text color={"text.mid"} visual={"bodyRegular"}>
          {description}
        </Text>
      </Flex>
      {showPrimaryButton && (
        <Button size={"lg"} {...primaryButtonProps}>
          {primaryButtonCopy}
        </Button>
      )}
      {primaryButtonReplacement && primaryButtonReplacement}
      {showSecondaryButton && (
        <Button size={"lg"} {...secondaryButtonProps}>
          {secondaryButtonCopy}
        </Button>
      )}
    </Flex>
  );
};
